import { Button, Stack, Text } from '@common/ui'
import { IconDownload } from '@common/ui/icons'
import AssetViewPage from '../asset/AssetViewPage'
import { KindViewPageProps } from '../KindPages'
import { getMimeTypeFromEntity, getResourceKeyFromEntity } from '../../../../io/entityResourceKeyLink'
import getResourceUrl from '../../../../io/api/resource/getResourceUrl'
import AssetPluginPreview from '../../../../plugins/AssetPluginPreview'
import useAssetPlugin from '../../../../plugins/useAssetPlugin'

const NoFileMessage = () => (
  <Text size="sm" c="dimmed">
    No file uploaded.
  </Text>
)

const GenericAssetViewPage = (props: KindViewPageProps) => {
  const { entity } = props
  const resourceKey = getResourceKeyFromEntity(entity)
  const mimeType = getMimeTypeFromEntity(entity)
  const plugin = useAssetPlugin(mimeType)

  const renderPreview =
    resourceKey && plugin?.uiPluginId
      ? () => (
          <Stack gap="xs" style={{ flex: 1, minHeight: 0 }}>
            <AssetPluginPreview
              pluginId={plugin.uiPluginId!}
              url={getResourceUrl(resourceKey)}
              mimeType={mimeType}
              entityId={entity.entity.id.toString()}
            />
          </Stack>
        )
      : resourceKey
        ? undefined
        : () => <NoFileMessage />

  return (
    <AssetViewPage
      {...props}
      renderPreview={renderPreview}
      renderSource={() =>
        resourceKey ? (
          <Stack gap="xs" align="flex-start">
            <Button
              component="a"
              variant="outline"
              leftSection={<IconDownload size={16} stroke={1.5} />}
              href={getResourceUrl(resourceKey)}
              download
            >
              Download
            </Button>
          </Stack>
        ) : (
          <NoFileMessage />
        )
      }
    />
  )
}

export default GenericAssetViewPage
